import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import VueCookie from 'vue-cookie'
import orders from './modules/order'
import ccsheet from './modules/ccsheet'
import storeorder from './modules/storeorder'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
    path: '*',
    redirect: '/login'
  }, {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/Login.vue'),
    beforeEnter (from, to, next) {
      if (!VueCookie.get('kilab_pwa_token')) {
        next()
      } else {
        next('/dashboard')
      }
    }
  }, {
    path: '/dashboard',
    component: () => import('@/views/dashboard/Index'),
    meta: { requiresAuth: true }
  },
  ...orders,
  ...ccsheet,
  ...storeorder
  ]
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!VueCookie.get(process.env.VUE_APP_TOKEN) || !VueCookie.get(process.env.VUE_APP_USER)) {
      store.commit('resetAuth', false)
      VueCookie.delete(process.env.VUE_APP_TOKEN)
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else next()
  } else next()
})

export default router
